<template>
    <BaseInput :label="attrs.label" :disabled="attrs.disabled">
        <template #input>
            <v-text-field
                ref="input"
                type="tel"
                solo flat
                :value="computedValue"
                @input="onInput"
                v-on="listeners"
                v-bind="attrs"
                v-mask="mask"
            >
            </v-text-field>
        </template>
    </BaseInput>
</template>

<script>
import { mask } from '@/utils/vue-the-mask'
import BaseInput from './BaseInput'

export default {
    name: 'SharedPhoneInput',
    inheritAttrs: false,
    directives: { mask },
    components: { BaseInput },
    props: {
        value: String,
    },
    data: vm => ({
        localValue: vm.value,

        mask: vm.$t('formats.phone_mask'),
    }),
    methods: {
        onInput(value) {
            // Retira as mensagens de erro caso o input não formatado tenha algum valor
            this.$emit('input', value.replace(/\D/g,'') ? value : null)
        },

        focus() {
            this.$refs.input.focus()
        },
    },
    computed: {
        computedValue() {
            // Alterar para internalização
            return this.localValue
        },

        /**
         * Extrai todos os listeners deste componente, exceto os que estamos sobrescrevendo
         */
        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        },
        /**
         * Extrai todas as props deste componente, exceto as que estamos sobrescrevendo
         */
        attrs() {
            const { value, ...attrs } = this.$attrs
            return { ...attrs }
        },
    },
    watch: {
        value(value) {
            this.localValue = value
        },
    },
}
</script>